module.exports = __webpack_public_path__ + "static/media/circle icon-4.3199d2bf.png";